var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundPageBgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 760,
    height: 749,
    viewBox: "0 0 760 749",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_48_275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.386,
    cy: 386.549,
    rx: 474.386,
    ry: 386.549,
    transform: "matrix(-0.584422 -0.81145 -0.81145 0.584422 857.812 386.88)",
    fill: "url(#paint0_linear_48_275)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_48_275",
    x: -225.725,
    y: -292.557,
    width: 985.262,
    height: 1040.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_48_275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_275",
    x1: 948.771,
    y1: 386.549,
    x2: 0,
    y2: 386.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831862,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPageBgLeft);
export default __webpack_public_path__ + "static/media/not-found-page-bg-left.668e43194179f71d045f0d9c7e56b46c.svg";
export { ForwardRef as ReactComponent };